<template>
    <div>
        <table class="table table-condensed table-prices">
            <thead>
                <tr>
                <th>Qty</th>
                <th v-if="perUnit > 1">
                    Price <small><em>per {{ perUnit }} units</em></small>
                </th>
                <th v-else>
                    Price <small><em>per unit</em></small>
                </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1 - {{ upperLimit() }}</td>
                    <td><product-price :price="price" :tax="tax"></product-price></td>
                </tr>
                <tr v-for="tier in tiers" :key="tier.id">
                    <td>
                        {{ tier.lower_limit }}
                        <template v-if="upperLimit(tier) < 9999999999999"> - {{ upperLimit(tier) }}</template>
                        <span v-else>+</span>
                    </td>
                    <td><product-price :price="tier.price" :tax="tier.tax || .01"></product-price></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import ProductPrice from '../Product/ProductPrice.vue';
    import Variant from '../../Services/Variant.js';

    export default {
        components: {
            ProductPrice
        },
        props: {
            tiers: {
                type: Array,
                default() {
                    return [];
                }
            },
            perUnit: {
                type: Number,
                default: 1
            },
            price: {
                type: [Number, String],
                default: 0
            },
            tax: {
                type: [Number, String],
                default: 0
            },
            quantity: {
                type: [Number, String],
                default: 1
            }
        },
        mounted() {
            this.$emit('priced', this.getPrice());
        },
        watch: {
            quantity() {
                this.$emit('priced', this.getPrice());
            }
        },
        methods: {
            getPrice() {
                if (this.current()) {
                    return {
                        price: this.current().price,
                        tax: this.current().tax
                    }
                }
                return {
                    price: this.price,
                    tax: this.tax
                };
            },
            current() {
                return Variant.currentTier(this.tiers, this.quantity)
            },
            upperLimit(tier) {
                return Variant.upperLimit(this.tiers, tier);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/PricingTable.vue